import React from "react";
import Body from "./Body";

const PRMarket = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default PRMarket;
